(function () {
  'use strict';

  var STORAGE_KEY = 'vrv_delivery_pincode_v2';
  var CACHE_PREFIX = 'vrv_pincode_meta_';
  var CACHE_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var EDD_CACHE_PREFIX = 'vrv_shiprocket_edd_';
  var EDD_CACHE_TTL_MS = 6 * 60 * 60 * 1000;

  function getConfig() {
    var c = window.vrvPincodeConfig || {};
    var spinUrl = c.spinWebhookUrl || '';
    var deliveryApiUrl = c.deliveryApiUrl || '';
    if (!deliveryApiUrl && spinUrl) {
      deliveryApiUrl = spinUrl.replace(/\/spin-event\/?$/, '/delivery-estimate');
    }
    if (!deliveryApiUrl) {
      deliveryApiUrl = 'https://vervit-discount-sync.rishika-35d.workers.dev/delivery-estimate';
    }
    return {
      useApi: c.useApi !== false,
      codEnabled: c.codEnabled !== false,
    deliveryApiUrl: deliveryApiUrl,
    pickupPostcode: String(c.pickupPostcode || c.pickup_postcode || '110030').trim(),
    unserviceableMessage: c.unserviceableMessage || 'Sorry, we do not deliver to {pincode} yet.',
      errorInvalid: c.errorInvalid || 'Please enter a valid 6-digit pincode.',
      shiprocketError: c.shiprocketError || 'Could not check delivery. Please try again in a moment.',
      pickupMissingError: c.pickupMissingError || 'Delivery check is not configured yet. Please contact the store.'
    };
  }

  function hasPickupPostcode(config) {
    config = config || getConfig();
    return /^\d{6}$/.test(String(config.pickupPostcode || '').trim());
  }

  function friendlyShiprocketError(message) {
    var config = getConfig();
    var msg = String(message || '');
    if (!msg) return config.shiprocketError;
    if (/SHIPROCKET_|not configured|credentials|login|password|auth|attempt|pickup pincode missing|blocked|too many|unauthorized|forbidden|502|error/i.test(msg)) {
      return config.shiprocketError;
    }
    return msg;
  }

  function format(template, vars) {
    var out = String(template || '');
    Object.keys(vars || {}).forEach(function (k) {
      out = out.replace(new RegExp('\\{' + k + '\\}', 'g'), vars[k] == null ? '' : String(vars[k]));
    });
    return out.replace(/,\s*,/g, ',').replace(/^\s*,\s*/, '').replace(/\s+/g, ' ').trim();
  }

  function formatShortDate(date) {
    if (!date || isNaN(date.getTime())) return '';
    try {
      return date.toLocaleDateString('en-IN', {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        timeZone: 'Asia/Kolkata'
      });
    } catch (e) {
      return date.toDateString();
    }
  }

  function applyShiprocketResult(data, sr) {
    if (!sr || !sr.ok) return data;
    data.source = 'shiprocket';
    data.cod = !!sr.cod;
    data.isExpress = !!sr.isExpress;
    data.isRemote = false;
    data.zone = sr.zone || sr.courierName || 'Shiprocket';
    data.courierName = sr.courierName || '';
    data.dateRange = sr.dateRange || '';
    data.deliveryMinLabel = sr.deliveryMinLabel || '';
    data.deliveryMaxLabel = sr.deliveryMaxLabel || '';
    data.daysMin = sr.estimatedDaysMin;
    data.daysMax = sr.estimatedDaysMax;
    data.eta = data.dateRange || (sr.estimatedDaysMin != null
      ? sr.estimatedDaysMin + (sr.estimatedDaysMax && sr.estimatedDaysMax !== sr.estimatedDaysMin
        ? '–' + sr.estimatedDaysMax
        : '') + ' days'
      : '');
    data.shiprocketCheckedAt = Date.now();
    return data;
  }

  function enrichPincodeData(data) {
    if (!data || typeof data !== 'object') return data;
    if (data.source !== 'shiprocket') {
      data.dateRange = '';
      data.deliveryMinLabel = '';
      data.deliveryMaxLabel = '';
      data.eta = '';
    }
    if (data.dateRange) return data;
    if (data.deliveryMinLabel) {
      data.dateRange = data.deliveryMinLabel === data.deliveryMaxLabel || !data.deliveryMaxLabel
        ? data.deliveryMinLabel
        : data.deliveryMinLabel + ' – ' + data.deliveryMaxLabel;
    }
    return data;
  }

  function hasShiprocketEstimate(data) {
    return !!(data && data.source === 'shiprocket' && (data.dateRange || data.deliveryMinLabel));
  }

  function formatDeliveryDisplay(data) {
    var config = getConfig();

    if (!data || !data.pincode) {
      return {
        title: 'Check delivery',
        meta: 'Enter your pincode for a Shiprocket delivery estimate',
        metaPrompt: 'Enter your pincode to see delivery date',
        dateRange: 'Enter pincode',
        trustDelivery: 'Enter pincode for delivery estimate',
        trustCod: config.codEnabled ? 'COD available on most pincodes' : 'Online payment only.',
        cod: false,
        codLabel: '',
        isDefault: true,
        hasPincode: false
      };
    }

    var enriched = enrichPincodeData(Object.assign({}, data));
    var hasEstimate = hasShiprocketEstimate(enriched);
    var parts = [];
    if (hasEstimate && enriched.isExpress) parts.push('\u26A1 Express delivery');
    if (hasEstimate && enriched.dateRange) {
      parts.push('Estimated delivery: ' + enriched.dateRange);
    } else if (hasEstimate && enriched.eta) {
      parts.push('Estimated delivery: ' + enriched.eta);
    } else {
      parts.push('Enter pincode to see Shiprocket delivery date');
    }
    if (hasEstimate && enriched.courierName) parts.push(enriched.courierName);
    else if (hasEstimate && enriched.zone && enriched.zone !== 'Shiprocket') {
      parts.push(enriched.zone);
    }
    if (hasEstimate && enriched.cod) parts.push('COD available');
    else if (hasEstimate) parts.push('Prepaid only');

    var loc;
    if (enriched.city && enriched.state) loc = enriched.city + ', ' + enriched.state;
    else if (enriched.city) loc = enriched.city;
    else loc = 'PIN ' + enriched.pincode;

    var dateText = hasEstimate
      ? (enriched.dateRange || enriched.eta || 'Checking...')
      : 'Enter pincode for delivery estimate';

    return {
      title: hasEstimate ? ('Delivering to ' + loc) : 'Check delivery',
      meta: parts.join(' \u00B7 '),
      metaPrompt: parts.join(' \u00B7 '),
      dateRange: dateText,
      trustDelivery: hasEstimate ? ('Delivered by ' + dateText) : 'Enter pincode for delivery estimate',
      trustCod: hasEstimate
        ? (enriched.cod ? 'Pay when your order arrives.' : 'Prepaid only for this pincode.')
        : (config.codEnabled ? 'COD available on most pincodes' : 'Online payment only.'),
      cod: hasEstimate ? !!enriched.cod : false,
      codLabel: hasEstimate ? (enriched.cod ? 'COD available' : 'Prepaid only') : '',
      isDefault: !hasEstimate,
      hasPincode: hasEstimate,
      zone: enriched.zone || ''
    };
  }

  function syncDeliveryUI(data) {
    var display = formatDeliveryDisplay(data || readSaved());
    try {
      document.querySelectorAll('[data-vrv-trust-delivery]').forEach(function (el) {
        el.textContent = display.trustDelivery;
      });
      document.querySelectorAll('[data-vrv-trust-cod]').forEach(function (el) {
        el.textContent = display.trustCod;
      });
      document.querySelectorAll('[data-vrv-cart-delivery-date]').forEach(function (el) {
        el.textContent = display.hasPincode ? display.dateRange : 'Enter pincode for estimate';
      });
      document.querySelectorAll('[data-vrv-delivery-info]').forEach(function (card) {
        if (card.classList.contains('is-editing')) return;
        var input = card.querySelector('[data-vrv-delivery-input]');
        var savedPin = (card.dataset.vrvSavedPincode || '').trim();
        var current = input ? input.value.trim() : '';
        if (current && savedPin && current !== savedPin) return;
        if (input && document.activeElement === input) return;
        var titleEl = card.querySelector('[data-vrv-delivery-title]');
        var metaEl = card.querySelector('[data-vrv-delivery-meta]');
        if (titleEl && metaEl && display.hasPincode) {
          titleEl.textContent = display.title;
          metaEl.textContent = display.meta;
          card.classList.add('is-set');
          card.dataset.vrvSavedPincode = (data && data.pincode) || (readSavedRaw() && readSavedRaw().pincode) || '';
        }
        if (window.vrvDeliveryInfoHelpers && typeof window.vrvDeliveryInfoHelpers.syncButtonState === 'function') {
          window.vrvDeliveryInfoHelpers.syncButtonState(card);
        }
      });
    } catch (e) {}
    return display;
  }

  function readSavedRaw() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function readSaved() {
    var parsed = readSavedRaw();
    if (!parsed || !parsed.pincode) return null;
    return enrichPincodeData(parsed);
  }

  function persist(data) {
    var enriched = enrichPincodeData(data);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(enriched));
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent('vrv:pincode:changed', { detail: enriched }));
    } catch (e2) {}
    syncDeliveryUI(enriched);
    return enriched;
  }

  async function lookupPincode(pincode) {
    var cacheKey = CACHE_PREFIX + pincode;
    try {
      var cached = JSON.parse(localStorage.getItem(cacheKey) || 'null');
      if (cached && (Date.now() - (cached._t || 0) < CACHE_TTL_MS)) return cached;
    } catch (e) {}

    try {
      var ctrl = new AbortController();
      var to = setTimeout(function () { ctrl.abort(); }, 4000);
      var res = await fetch('https://api.postalpincode.in/pincode/' + pincode, {
        signal: ctrl.signal,
        mode: 'cors',
        cache: 'force-cache'
      });
      clearTimeout(to);
      if (!res.ok) return null;
      var arr = await res.json();
      if (!Array.isArray(arr) || !arr[0]) return null;
      var payload = arr[0];
      if (payload.Status !== 'Success' || !Array.isArray(payload.PostOffice) || !payload.PostOffice.length) {
        var neg = { _t: Date.now(), apiInvalid: true };
        try { localStorage.setItem(cacheKey, JSON.stringify(neg)); } catch (e2) {}
        return neg;
      }
      var po = payload.PostOffice[0];
      var meta = {
        _t: Date.now(),
        pincode: pincode,
        city: po.District || po.Division || po.Block || '',
        state: po.State || '',
        country: po.Country || 'India'
      };
      try { localStorage.setItem(cacheKey, JSON.stringify(meta)); } catch (e3) {}
      return meta;
    } catch (e4) {
      return null;
    }
  }

  function readEddCache(pincode) {
    try {
      var cached = JSON.parse(localStorage.getItem(EDD_CACHE_PREFIX + pincode) || 'null');
      if (cached && cached.ok && (Date.now() - (cached._t || 0) < EDD_CACHE_TTL_MS)) {
        return cached;
      }
    } catch (e) {}
    return null;
  }

  function writeEddCache(pincode, result) {
    try {
      localStorage.setItem(EDD_CACHE_PREFIX + pincode, JSON.stringify(Object.assign({ _t: Date.now() }, result)));
    } catch (e) {}
  }

  async function fetchShiprocketEstimate(pincode, options) {
    options = options || {};
    var config = getConfig();
    var pickup = hasPickupPostcode(config) ? String(config.pickupPostcode).trim() : '';

    if (!options.forceRefresh) {
      var cached = readEddCache(pincode);
      if (cached) return cached;
    }

    var ctrl = new AbortController();
    var to = setTimeout(function () { ctrl.abort(); }, 8000);
    var res;
    try {
      res = await fetch(config.deliveryApiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          pincode: pincode,
          cod: config.codEnabled,
          pickupPostcode: pickup || undefined
        }),
        signal: ctrl.signal,
        mode: 'cors',
        credentials: 'omit'
      });
    } finally {
      clearTimeout(to);
    }

    var body = null;
    try {
      body = await res.json();
    } catch (e) {
      body = null;
    }

    if (!res.ok || !body) {
      return {
        ok: false,
        error: friendlyShiprocketError(body && body.message)
      };
    }

    if (!body.ok) {
      return {
        ok: false,
        serviceable: false,
        error: friendlyShiprocketError(body.message) || format(config.unserviceableMessage, { pincode: pincode })
      };
    }

    writeEddCache(pincode, body);
    return body;
  }

  async function checkPincode(pincode) {
    var config = getConfig();
    if (!/^\d{6}$/.test(String(pincode || '').trim())) {
      return { ok: false, error: config.errorInvalid };
    }

    pincode = String(pincode).trim();
    var meta = null;

    // Start both lookups together: they used to run one after the other, so a
    // slow city lookup delayed the delivery estimate by up to its full timeout.
    var estimateOnce = function () {
      return fetchShiprocketEstimate(pincode).catch(function () {
        return { ok: false, error: config.shiprocketError, _network: true };
      });
    };
    var metaPromise = config.useApi ? lookupPincode(pincode) : Promise.resolve(null);
    var srPromise = estimateOnce().then(function (first) {
      // One quick retry for a transient network/worker hiccup.
      if (first && (first._network || (first.ok === false && first.serviceable !== false))) {
        return new Promise(function (resolve) { setTimeout(resolve, 400); }).then(estimateOnce);
      }
      return first;
    });

    var settled = await Promise.all([metaPromise, srPromise]);
    meta = settled[0];
    var sr = settled[1];
    if (meta && meta.apiInvalid) {
      return { ok: false, error: format(config.unserviceableMessage, { pincode: pincode }) };
    }

    if (!sr || !sr.ok) {
      return {
        ok: false,
        error: (sr && sr.error) || format(config.unserviceableMessage, { pincode: pincode })
      };
    }

    var finalData = persist(applyShiprocketResult({
      pincode: pincode,
      city: (meta && meta.city) || '',
      state: (meta && meta.state) || '',
      savedAt: Date.now()
    }, sr));

    return { ok: true, data: finalData };
  }

  async function refreshSavedPincode() {
    var raw = readSavedRaw();
    if (!raw || !raw.pincode) {
      syncDeliveryUI(null);
      return null;
    }

    if (getConfig().useApi && (!raw.state || !raw.city)) {
      var meta = await lookupPincode(raw.pincode);
      if (meta && !meta.apiInvalid) {
        raw.city = meta.city || raw.city || '';
        raw.state = meta.state || raw.state || '';
      }
    }

    var stale = !raw.shiprocketCheckedAt || (Date.now() - raw.shiprocketCheckedAt > EDD_CACHE_TTL_MS);
    var legacy = raw.source !== 'shiprocket' || !raw.dateRange;
    if (stale || legacy) {
      try {
        var sr = await fetchShiprocketEstimate(raw.pincode, { forceRefresh: true });
        if (sr && sr.ok) {
          raw = applyShiprocketResult(raw, sr);
        }
      } catch (e) {}
    }

    var rebuilt = enrichPincodeData(raw);
    if (!rebuilt.dateRange && !rebuilt.eta) {
      syncDeliveryUI(null);
      return null;
    }

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(rebuilt));
    } catch (e) {}

    syncDeliveryUI(rebuilt);
    try {
      document.dispatchEvent(new CustomEvent('vrv:pincode:changed', { detail: rebuilt }));
    } catch (e2) {}
    return rebuilt;
  }

  function initDeliveryUI() {
    refreshSavedPincode();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeliveryUI);
  } else {
    initDeliveryUI();
  }
  document.addEventListener('vrv:pincode:changed', function (ev) {
    syncDeliveryUI(ev && ev.detail ? ev.detail : readSaved());
  });

  window.VrvPincodeService = {
    getConfig: getConfig,
    readSaved: readSaved,
    readSavedRaw: readSavedRaw,
    persist: persist,
    checkPincode: checkPincode,
    fetchShiprocketEstimate: fetchShiprocketEstimate,
    enrichPincodeData: enrichPincodeData,
    formatDeliveryDisplay: formatDeliveryDisplay,
    syncDeliveryUI: syncDeliveryUI,
    refreshSavedPincode: refreshSavedPincode
  };
})();
